module.exports = __webpack_public_path__ + "static/media/Icon_Electrical.048116ad.png";